<template>
  <div class="pharmacy-header ptb-4">
    <b-row class="">
      <b-col cols="12" md="3" class="p-3 text-center">
        <PictureFallback
          :src="pharmacy.logo"
          type="pharmacy"
          class="img-fluid w-50 mx-auto d-block h-85"
          alt="pharmacy logo"
        />
        <div class="mt-2">
          {{ pharmacyEmail }}
        </div>
        <!-- No queremos mostrar esta información, de momento. La volveremos
        a mostrar cuando podamos editar/gestionar bien esa información en el BO -->
        <!-- <div>
          {{ pharmacy.phone }}
        </div>
        <div class="pharmacy-email">
          <b-link :href="'mailto:' + pharmacy.email">
            {{ pharmacy.email }}
          </b-link>
        </div> -->
      </b-col>
      <b-col cols="12" md="9" class="p-3 d-none d-md-block mw-100 mh-100">
        <PictureFallback
          :src="pharmacy.image_header"
          alt="pharmacy banner"
          type="pharmacy_header"
        />
      </b-col>
    </b-row>
  </div>
</template>


<script>
import PictureFallback from "@/components/PictureFallback";

const MAILING_TYPE_ORDER = 2;

export default {
  name: "pharmacy-detail",
  components: {
    PictureFallback,
  },
  props: {
    pharmacy: Object,
  },
  computed: {
    pharmacyOrdersEmail() {
      const orders_emails = this.pharmacy.configuration.mailing_configurations.filter(
        (m) => m.mailing_type === MAILING_TYPE_ORDER
      );
      if (orders_emails.length > 0) {
        return orders_emails[0].email;
      }
      return undefined;
    },
    pharmacyEmail() {
      return this.pharmacyOrdersEmail || this.pharmacy.email;
    },
  },
};
</script>


<style lang="scss" scoped>
.h-85 {
  height: 85%;
}
.pharmacy-email a {
  color: $text-main-color;

  &:hover {
    text-decoration: none;
  }
}

.pharmacy-header {
  height: 14rem;
  overflow: hidden;
}
</style>
